module.exports = __webpack_public_path__ + "e0a3ad93b29bc46806e9dddc6d75cf6f.pdf";